export default {
  name: 'meta',
  namespaced: true,
  state: {
    meta: null,
  },
  mutations: {
    set(state, m) {
      state.meta = m
    },
  },
  actions: {
    set({ commit }, m) {
      commit('set', m)
    },
  },
}
